import { FETCH_START, FETCH_END, RestMethods } from "jazasoft";
import { dataProvider } from "../App";

const fetchSetting = (key, dispatch, cb) => {
  const options = {
    url: `settings/${key}`,
    method: "get"
  };
  dispatch && dispatch({ type: FETCH_START });
  dataProvider(RestMethods.CUSTOM, undefined, options)
    .then(response => {
      if (response.status === 200) {
        cb && cb(response.data);
      }
      dispatch && dispatch({ type: FETCH_END });
    })
    .catch(err => {
      console.log(err);
      dispatch && dispatch({ type: FETCH_END });
    });
};

export default fetchSetting;
